<template>
    <div>
      <el-dialog :visible="visible" title="发送日志" width="960px" :before-close="handleClose" class="cycleDialog">
        <div class="search-box">
          <el-form ref="formSearch" :inline="true" :model="form" label-width="100px">
            <el-form-item label="发送状态：">
              <el-select size="small" v-model="form.status">
                <el-option
                  v-for="(item, index) in sendStatus"
                  :key="index"
                  :value="item.value"
                  :label="item.label"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="发送时间：">
              <div class="my_select_time">
                <el-date-picker
                  prefix-icon="no_icon"
                  v-model="form.sendStartTime"
                  type="datetime"
                  :placeholder="'选择日期时间'"
                  size="small"
                  format="yyyy-MM-dd HH:mm:ss"
                  :picker-options="startTimeOption"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 120px; font-size: 12px"
                  class="time1"
                  :clearable="false"
                ></el-date-picker>
                <div class="time_to_text" style="margin-top: 1px !important">
                  至
                </div>
                <el-date-picker
                  prefix-icon="no_icon"
                  v-model="form.sendEndTime"
                  type="datetime"
                  :placeholder="'选择日期时间'"
                  :picker-options="endTimeOption"
                  size="small"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 145px; font-size: 12px"
                  default-time="23:59:59"
                  class="time2"
                  :clearable="false"
                ></el-date-picker>
                <i
                  class="el-icon-circle-close date_icon1"
                  @click="clearTimeSendTime()"
                ></i>
                <img
                  src="@/assets/images/select_date.svg"
                  alt
                  class="date_icon2"
                />
              </div>
            </el-form-item>       
            <div class="button-group">
              <el-button size="small" class="search" type="primary"  @click="submitForm()"> 
                    <i class="el-icon-search" style="display:inline-block;width:14px;height:12px;"></i> 查询
                </el-button>
                <el-button size="small" class="reset" type="primary"  @click="resetForm">重置</el-button>
            </div>
          </el-form>
          <div class="table-box">
            <el-table ref="table" v-loading="tableLoading" :data="tableData" tooltip-effect="light" 
            style="width: 100%; border: 1px solid #eee"
            :cell-style="{ 'text-align': 'center' }"
            height="400"
            :header-cell-style="{ background: '#fafafa', 'text-align': 'center' }">
            <template slot="empty">
              <div>
                <img src="@/assets/images/default/暂无任何数据.png" />
                <span style="margin-left: -140px">暂无任何数据</span>
              </div>
            </template>
              <el-table-column label="发送时间" prop="sendTime" width="200px"></el-table-column>
              <el-table-column label="发送群数量" prop="sendGroupNum"></el-table-column>
              <el-table-column label="发送状态" prop="status">
                <template slot-scope="scope">
                    <div>
                    <span v-if="scope.row.status == 1">待发送</span>
                    <span v-else-if="scope.row.status == 2">已发送</span>
                    <span v-else-if="scope.row.status == 3">发送失败
                        <el-tooltip class="item" effect="light" :content="scope.row.failReason" placement="top-start">
                            <span class="question_icon">?</span>
                        </el-tooltip>
                    </span>
                    <span v-else-if="scope.row.status == 4">未开始</span>
                    <span v-else-if="scope.row.status == 5">进行中</span>
                    <span v-else>已结束
                        <el-tooltip class="item" effect="light" :content="scope.row.overReason" placement="top-start">
                            <span class="question_icon">?</span>
                        </el-tooltip>
                    </span>
                    </div>
                </template>
                </el-table-column>
            </el-table>
            <div>
            <!-- 分页器 -->
            <el-pagination
            background
            style="text-align: right; margin-top: 20px;"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="form.current"
            :page-sizes="[5, 10, 20, 30, 50, 100]"
            :page-size="form.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            ></el-pagination>
            </div>
          </div>
        </div>
      </el-dialog>
    </div>
</template>
  
<script>
import {getCycleDetail} from "@/api/marketing/dongdong";
export default {
    
    props: {
        isShow: {
            type: Boolean,
            default: false,
        },
        cycleId:{
          type:Number,
          default: "",
        }
    },
    components: {
      getCycleDetail,
  },
    data() {
        return{
            visible:this.isShow,
            form: {
                current: 1,
                size: 5,
                status: "",
                sendStartTime: "",
                sendEndTime: "",
                id:this.cycleId
            }, // 记录查询条件
            sendStatus: [
                {
                label: "全部",
                value: "",
                },
                {
                label: "待发送",
                value: "1",
                },
                {
                label: "已发送",
                value: "2",
                },
                {
                label: "发送失败",
                value: "3",
                },
                {
                label: "未开始",
                value: "4",
                },
                {
                label: "进行中",
                value: "5",
                },
                {
                label: "已结束",
                value: "6",
                },
            ],
            startTimeOption: {
            disabledDate: (date) => {
                var endTime = this.form.sendEndTime;
                var time = date.getTime();
                var isDisabled = false;
                if (endTime) {
                    isDisabled = time > new Date(endTime).getTime();
                }
                return isDisabled;
                }
            },
            endTimeOption: {
                disabledDate: (date) => {
                var startTime = this.form.sendStartTime;
                var time = date.getTime();
                var isDisabled = false;
                if (startTime) {
                    isDisabled = time < new Date(startTime).getTime();
                }
                return isDisabled;
                }
            },
            tableData: [],
            total: 0,
            tableLoading: false,
        };
    },
    mounted() {
      this.getDataList()
    },
    methods: {
      //获取列表详情
      getDataList(){
        this.tableLoading = true
        console.log("this.form",this.form)
        getCycleDetail(this.form).then(res => {
        console.log(res);
         if (res.code == "1") {
          this.tableLoading =false
            this.tableData = res.data.records
            this.total=res.data.total
            this.form.current =res.data.current
        } else {
          this.tableLoading =false
          this.$message.error(res.message);
        }
      })
      },
      //提交查询
      submitForm(){
        this.getDataList();
      },
      // 重置
      resetForm() {
        this.form = {
            current: 1,
            size: 5,
            sendType: "",
            sendState: "",
            sendStartTime: "",
            sendEndTime: "",
            id:this.cycleId
        };
          this.getDataList();
      },
      //清除时间
      clearTimeSendTime(){
        this.form.sendStartTime = ""
        this.form.sendEndTime = ""
      },
      //关闭
      handleClose() {
        this.$emit("close", false);
      },
      handleSizeChange(size) {
        this.form.size = size;
        this.getDataList();
      },
      handleCurrentChange(current) {
        this.form.current = current;
        this.getDataList();
      },
    }
  }
  </script>
  
<style lang="scss" scoped>
  .search-box{
    .el-input, .el-select{
        width: 136px;
    }
    .button-group{
        display: inline-block;
        margin-left: 20px;
        .search{
        width: 98px;
        height: 32px;
        color: #fe4d45;
        border: 1px solid #fe4d45 ;
        background-color: #fff;
        &:hover{
            color: #fff ;
            border: 1px solid #fff;
            background-color: #fe4d45;
            }
        }.reset{
            width: 98px;
            height: 32px;
            color: #666666;
            border: 1px solid #dddddd;
            background-color: #fff;
            &:hover{
            color:#fe4d45 ;
            border: 1px solid #fe4d45;
            background-color: #FFF4F4;
            }
        }
    }
 }
 .question_icon {
  width: 14px;
  height: 14px;
  color: #fe4d45 !important;
  display: inline-block;
  line-height: 12px !important;
  text-align: center;
  border-radius: 14px;
  border: 1px solid #fe4d45;
  font-size: 12px !important;
  font-weight: normal !important;
  margin-left: 8px;

  &:hover {
    color: #fe4d45 !important;
    border: 1px solid #fe4d45;
  }
}

</style>
  